import React, { useEffect, useState } from "react";
import moment from "moment";

const SvgWave = ({ data, boxInfo, style, handleSelectBoxTimeInfo,handleDoubleClick,patientDischargeMarker }) => {        
    const barWidth = (boxInfo.width-2) / data.length; // 각 웨이브의 폭 - border 떄문에 양쪽 2 width를 제거 & 각 영역의 width를 구함.    

    //전체 데이터의 최대 최소값 -75 +75로 간격 변경. & -2147483648는 이전 값으로 대체 처리 (-2147483648는 페이스메이커로 제외 처리 해야 됨)
    const combinedWave = data.flatMap((item, dataIndex) => 
        item.wave.map((value, waveIndex) => {
            if (value == '-2147483648') {
                // 같은 웨이브 내의 이전 포인트가 있으면 사용
                if (waveIndex > 0) {
                    return item.wave[waveIndex - 1];
                }
                // 이전 데이터 아이템의 같은 위치 포인트가 있으면 사용
                if (dataIndex > 0 && data[dataIndex - 1]?.wave[waveIndex] != '-2147483648') {
                    return data[dataIndex - 1].wave[waveIndex];
                }
                // 둘 다 없으면 0 또는 기본값 사용
                return 0;
            }
            return value;
        })
    );            

    const defaultMinY = -150
    const defaultMaxY = 300
    let minY = Math.min(...combinedWave) - ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);
    let maxY = Math.max(...combinedWave) + ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);

    minY = Math.min(minY, defaultMinY)
    maxY = Math.max(maxY, defaultMaxY)  

    // wave 데이터 Y축을 SVG에 맞게 정규화
    const normalizeY = (value, min, max) => {
        if (value === 0 && min === 0 && max === 0) {            
            return boxInfo.height / 2; 
        }
        return boxInfo.height - ((value - min) / (max - min)) * boxInfo.height;
    };

    // 선택된 wave의 중앙 X 좌표를 계산하는 함수
    const getWaveCenterX = (waveData, index) => {        
        return index * barWidth + barWidth / 2;
    };

    return (
        <svg            
            width={boxInfo.width} 
            height={boxInfo.height}
            // onDoubleClick={() => handleDoubleClick()}
            className={style}
        >
            {data.map((waveData, index) => {
                const backgroundX = index * barWidth;
                const backgroundWidth = barWidth;

                // 각 웨이브의 포인트 계산
                const points = waveData.wave
                    .map((y, i) => {          
                        let adjustedY = y;
                        
                        // -2147483648인 경우 이전/다음 값으로 대체
                        if (y == '-2147483648') {
                            // 이전 값이 있고 유효한 경우
                            if (i > 0 && waveData.wave[i - 1] != '-2147483648') {
                                adjustedY = waveData.wave[i - 1];
                            }
                            // 다음 값이 있고 유효한 경우
                            else if (i < waveData.wave.length - 1 && waveData.wave[i + 1] != '-2147483648') {
                                adjustedY = waveData.wave[i + 1];
                            }
                            // 둘 다 없으면 0으로 설정
                            else {
                                adjustedY = 0;
                            }
                        }
                        
                        const x = (barWidth / (waveData.wave.length - 1)) * i + index * barWidth;
                        const normalizedY = normalizeY(adjustedY, minY, maxY);
                        
                        return `${x},${normalizedY}`;
                    })
                    .join(" ");
                
                const waveCenterX = getWaveCenterX(waveData, index);
                
                return (
                    // 선택 영역 업데이트                    
                    <g key={index} onClick={() => {handleSelectBoxTimeInfo();}} onDoubleClick={() => handleDoubleClick('wave',data[0].createdAt)}>
                        <rect
                            x={backgroundX}
                            y={0}
                            width={backgroundWidth}
                            height={boxInfo.height}
                            fill="transparent"                              
                        />                        
                        <polyline
                            points={points}
                            fill="none"
                            stroke="#8A8A8A"
                            strokeWidth={boxInfo.strokeWidth}
                        />

                        {
                            patientDischargeMarker.map((marker,index) => {                                                                
                                return (
                                    moment(waveData.createdAt).isSame(moment(marker.formattedTime)) ? (      
                                        <g key={index} transform={`translate(${waveCenterX - 5}, ${boxInfo.height / 2 - 15})`}>
                                            <path d="M8 6V0H2L8 6Z" fill="#CECECE" />
                                            <rect x="7" y="5" width="1" height="18" fill="#CECECE" />
                                            <path d="M8 22V28H2L8 22Z" fill="#CECECE" />
                                        </g>
                                    ) : null
                                )
                            })
                        }
                    </g>
                );
            })}
        </svg>
    );
};

export default SvgWave;